export const deviceSetToCustomerFields = [
  {
    label: 'IMEI',
    key: 'imei',
  },
  {
    label: 'Customer Domain',
    key: 'customer_domain',
  },
  {
    label: 'SIM Card Number',
    key: 'sim_card_number',
  },
  {
    label: 'License Plate',
    key: 'license_plate',
  },
  {
    label: 'Vehicle Type',
    key: 'vehicle_type',
  },
  {
    label: 'Odometer (Meters)',
    key: 'odometer',
  },
  {
    label: 'Vehicle Year',
    key: 'vehicle_year',
  },
  {
    label: 'Hull Number',
    key: 'hull_no',           // Asumsi sebelumnya sudah ada, tapi kita tambahkan agar lengkap
  },
  {
    label: 'WO Number',       // BARU
    key: 'wo_number',
  },
  {
    label: 'Note',         // BARU
    key: 'note',
  },
].map((field) => ({
  ...field,
  isSortable: true,
  showErrorKey: field.key,
  thAttr: {
    style: 'min-width:180px;',
  },
}))

// Tambahkan fungsi untuk memformat error message (tidak perlu diubah, sudah generik)
export const transformErrorDataToTableFormat = (errorData) => {
  // If there's no data or it's not an object, return an empty array
  if (!errorData || typeof errorData !== 'object') {
    return []
  }

  // Check if it's the summarized format (with failed_*)
  const hasFailedFields = Object.keys(errorData).some((key) => key.startsWith('failed_'))

  if (hasFailedFields) {
    // Process the summarized format
    const tableData = []

    // Extract all failed_* fields
    Object.entries(errorData)
      .filter(([key]) => key.startsWith('failed_') && Array.isArray(errorData[key]))
      .forEach(([key, values]) => {
        const fieldName = key.replace('failed_', '')

        // For each value in the array, create a row
        values.forEach((value) => {
          const row = {}
          // Set the value for the corresponding field
          row[fieldName] = value

          // Add specific error for this field
          // Instead of using error_message, use a structure that
          // allows showing the error in the specific field
          row.error = {
            [fieldName]: `Failed to set ${fieldName}`,
          }

          tableData.push(row)
        })
      })

    return tableData
  } else {
    // Process the detailed format (with Row X)
    return Object.entries(errorData)
      .filter(([key]) => key.startsWith('Row'))
      .map(([rowKey, rowData]) => {
        // Create a copy of the row data
        const row = { ...rowData }

        // Add row number as reference
        row.row_number = rowKey

        // We don't need to add error_message since errors
        // are already in the 'error' property of each row
        // and will be displayed in the corresponding fields

        return row
      })
  }
}
